import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import { IconComponent } from '@shared/components/icon/icon.component';
import { MessagesConstants } from '@shared/constants/messages.constants';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { PermissionType } from '@shared/services/gql.service';
import { AuthService } from '@shared/store/auth/auth.service';
import { Utils } from '@shared/utils/utils';

import { GatherContractsRoutes } from './gather-contracts-routes';
import {
  ChecklistComponentData,
  ChecklistComponentDataAddPoReport,
} from '../../models/quarter-close-checklist.model';
import { ChecklistRowInfoComponent } from '../checklist-row-info/checklist-row-info.component';

@Component({
  imports: [RouterLink, TooltipDirective, IconComponent, AsyncPipe],
  styleUrls: ['../../quarter-close-checklist.component.scss'],
  templateUrl: './checklist-section-gather-contracts.component.html',
})
export class ChecklistSectionGatherContractsComponent implements ChecklistComponentData {
  private authService = inject(AuthService);
  private readonly destroyRef = inject(DestroyRef);

  available = true;
  data: ChecklistComponentDataAddPoReport = {
    addPoReportUploadClick: () => {},
    disabledLock: false,
  };
  readonly GatherContractsRoutes = GatherContractsRoutes;
  hasPOPermission$ = new BehaviorSubject<boolean>(false);
  id = 'GatherContracts';
  readonly messagesConstants = MessagesConstants;
  parent!: ChecklistRowInfoComponent;
  zeroHyphen = Utils.zeroHyphen;

  constructor() {
    this.authService
      .isAuthorized$({
        permissions: [PermissionType.PERMISSION_UPDATE_PURCHASE_ORDERS],
        sysAdminsOnly: false,
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((perm) => this.hasPOPermission$.next(perm));
  }
}
